import React from 'react';
import { Instagram, Download } from 'lucide-react';

export default function AppFooter({ showInstallButton, onInstallClick }) {
  return (
    <footer className="mt-12 pt-6 border-t border-surface-border-light">
      <div className="flex flex-col items-center justify-center gap-4">
        <a
          href="https://www.instagram.com/tapsody.app/"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-transparent hover:bg-brand transition p-2 rounded-full"
          title="Follow us on Instagram"
        >
          <Instagram className="w-5 h-5 text-white" />
        </a>
        <p className="text-text-subtle text-sm text-center">
          Built in the EU. All content copyright © 2026 Tapsody App - Chamber of Commerce: 42033957, Rotterdam, The Netherlands
        </p>
        {showInstallButton && (
          <button
            onClick={onInstallClick}
            className="bg-transparent border border-surface-border-light hover:bg-brand hover:border-brand transition px-6 h-[42px] font-semibold flex items-center gap-2 text-sm rounded-card-btn"
          >
            <Download className="w-4 h-4" />
            Install App
          </button>
        )}
      </div>
    </footer>
  );
}
